module.exports = __webpack_public_path__ + "img/star.ac8ea213.svg";